<template>
	<div class="pt-3 px-5 pb-2 page-fill">
		<div class="items-center justify-between flex ResponsiveStartAudit">
			<div class="title flex items-center">
				<h1>My Tasks</h1>
			</div>
            <div>
                <button :class="tableRow.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton'" class="flex" @click="filterOpen" >
                    <img v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
                    <img v-else src="@/assets/filter.svg" class="filterIcon" />
                    Filters
                </button>
			</div>
		</div>
		<div class="mt-5 ResponsiveStartAudit">
			<p class="headerText">
                My Tasks acts as your individual to-do list and automatically gathers tasks assigned to you across all Audits, enabling you to see and organize your work in one centralized place.
			</p>
		</div>
        <div class="table-section">
			<tableData class="flex-1 min-h-0" :tableRowData="tableRow" :headersData="mainHeaders" :loadData="dataLoading"></tableData>
            <div v-if="toolTipActive">
				<tool-tip :tipText="toolTipText"></tool-tip>
			</div>
		</div>

	</div>
</template>
<style scoped>
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { required } from '@vuelidate/validators';
import { mapGetters } from 'vuex';
import { emitter, toast } from '@/main';
import tableData from '@/components/tableData.vue';
import toolTip from '@/components/toolTip.vue'
import moment from 'moment';

export default defineComponent({
	data(): any {
		return {
			showFilters: false,
            visibility: false,
            allFrameWorkControls:[],
            filters: {},
            tableRow:[],
            mainHeaders:[],
			dummyList:[],
            teamObject:[],
            locationObject:[],
            auditStatusCodes: [
				{
					id: 10401,
					value: 'Not Started'
				},
				{
					id: 10414,
					value: 'Pending Evidence'
				},
				{
					id: 10415,
					value: 'InReview'
				},
                {
					id: 10416,
					value: 'Evidence Uploaded'
				},
                {
					id: 10403,
					value: 'Completed'
				},
                {
					id: 10417,
					value: 'Not Applicable'
				},

			],
            routesArray: [],
            myTasksArray:[],
            teamsData:[],
            toolTipActive:false,
			toolTipText:'',
            dataLoading:true
		};
	},
	components: {
        tableData,
        toolTip
	},
	computed: {
		...mapGetters({ userInfo: 'userInfo' }),
	},
    async mounted(){
        emitter.on('visible', (isBoolean: any) => {
			this.visibility = isBoolean;
			this.visibility == false ? this.filters = {}:'';
		});

        this.bindTaskTableListeners();
        emitter.off('detailsModalClosed', this.onDetailsModalClosed)
        emitter.on('detailsModalClosed', this.onDetailsModalClosed)

        emitter.off('activiteToolTip');
        emitter.on('activiteToolTip', (data: any) => {
            if (this.isDetailsModalOpen()) {
                return;
            }
            this.toolTipActive = true;
            this.toolTipText = data.tipText
        });
 
        emitter.off('deActiviteToolTip');
        emitter.on('deActiviteToolTip', (data: any) => {
            this.toolTipActive = false;
            this.toolTipText = ''
        });
    },
	beforeUnmount() {
		emitter.off('clickedOnTableRow', this.onTaskTableRowClick)
		emitter.off('detailsModalClosed', this.onDetailsModalClosed)
	},
	methods: {
        filterOpen() {
			this.showFilters = !this.showFilters;
			if (this.showFilters == true) {
                this.dummyList = this.tableRow;
            } else {
                this.tableRow = this.dummyList;
            }
			emitter.emit('visible', this.showFilters);
		},
        isDetailsModalOpen() {
            return !!document.querySelector('.details-modal-overlay');
        },
        bindTaskTableListeners() {
            emitter.off('clickedOnTableRow')
            emitter.on('clickedOnTableRow', this.onTaskTableRowClick)
        },
        async onDetailsModalClosed() {
            this.bindTaskTableListeners();
            const scrollEl = this.$el?.querySelector?.('.table-body-scroll') as HTMLElement | null;
            const scrollTop = scrollEl?.scrollTop || 0;
            await this.refreshAfterDetailsModal();
            await this.$nextTick();
            const restored = this.$el?.querySelector?.('.table-body-scroll') as HTMLElement | null;
            if (restored) {
                restored.scrollTop = scrollTop;
            }
        },
        onTaskTableRowClick(actionObj:any){
            if(this.isDetailsModalOpen()){
                return;
            }
            this.toolTipActive = false;
            this.toolTipText = '';
            emitter.emit('deActiviteToolTip');
            this.goToControlTaskEdit(actionObj.auditId,actionObj._id)
        },
        goToControlTaskEdit(auditId:any,taskId:any){
            emitter.emit('openDetailsModal', {
                view: 'controlEdit',
                title: 'Task',
                params: { auditId: auditId, taskId: taskId, myTasks: true },
            });
        },
        async refreshAfterDetailsModal() {
            this.dataLoading = true;
            this.tableRow = [];
            await this.getTasksForPerson();
            await this.getDetailsForTable();
            this.dataLoading = false;
        },
        async getAllTeams() {
            this.teamObject = []
            let users:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                users = res.data;
                this.teamsData = res.data
            });
            for (var i = 0; i < users.length; i++) {
                this.teamObject.push({ label: users[i].teamName, value: users[i]._id });
            }
        },
		 async getallEntities() {
            this.locationObject = []
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityDisplayName, value: result[i]._id,entityType:result[i].entityType });
            }
        },
         getLocationName(locationId: any) {
            let user = this.locationObject.find((obj: any) => {
                return obj.value == locationId;
            });
            if (user == undefined) {
                let empty = 'N/A';
                return empty;
            } else {
                return user.label;
            }
        },
        async getTasksForPerson(){
            let auditorPayload:any = {
                "type":1,
                "auditor": this.userInfo._id,
                "organisationType":this.userInfo.organisationType,
                "roleId":this.userInfo.organisationType==10701?this.userInfo.role_id:''
            }
            this.myTasksArray = [];
            try{
                 await this.$http.post(`${process.env.VUE_APP_AUDIT_API}/api/org/tasks/getall/byroles`,auditorPayload).then((result: any) => {
                   this.myTasksArray = result.data;
                });
            }catch{
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },

        async getDetailsForTable(){

            this.tableRow = []
            if(this.myTasksArray!=null||this.myTasksArray!=undefined){
            this.myTasksArray.map((taskObj:any)=>{

                let presentLocation:any
                
                let presentteamObject:any = this.teamsData.find((obj: any) => {
                    return obj._id == taskObj.department;
                });

                if (presentteamObject != undefined && presentteamObject.entityType == 20301){
                    presentLocation = this.locationObject.find((l:any)=>l.entityType==1)?.label||'N/A';
                }else if(presentteamObject != undefined && presentteamObject.entityType == 20303){
                    // presentLocation = this.getLocationName(presentteamObject.entityId)
                    presentLocation = presentteamObject.entityDisplayName
                }

                let sendObject:any = { 
                    "_id": taskObj._id,
                    "auditId":taskObj.auditId != undefined ? taskObj.auditId : 'N/A', 
                    "taskId": taskObj.taskId  != undefined ? taskObj.taskId : 'N/A',
                    "CID": taskObj.clientUniqueId != undefined ? taskObj.clientUniqueId : 'N/A',
                    "controlName": taskObj.controlTitle != undefined ? taskObj.controlTitle : 'N/A', 
                    "teamName": presentteamObject?.displayName  != undefined ? presentteamObject.displayName : 'N/A',
                    "entityName": presentLocation  != undefined ? presentLocation : 'N/A',
                    "dueDate":taskObj.dueDate!=undefined?moment(taskObj.dueDate).format('DD-MM-YYYY'):'N/A',
                    "taskStatus": taskObj.statusCode != undefined ? taskObj.statusCode : 'N/A',
                };

                this.tableRow.push(sendObject)
            })
            }
        }
	},

	async created() {
        this.dataLoading = true;

        let headersData = ['taskId','CID','controlName','teamName','entityName','dueDate','taskStatus']

        this.mainHeaders = headersData;

        await this.getAllTeams();
        await this.getallEntities();
        await this.getTasksForPerson()

        await this.getDetailsForTable();

        this.dataLoading = false;
    },
});
</script>
